import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Placeholder from "@tiptap/extension-placeholder";
import Link from "@tiptap/extension-link";
import { Markdown } from "tiptap-markdown";
import Table from "@tiptap/extension-table";
import TableRow from "@tiptap/extension-table-row";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import { TemplatePlaceholders } from "./templatePlaceholders";

export function caseBriefEditorExtensions(placeholder: string) {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3, 4] }
    }),
    Underline,
    Markdown.configure({
      html: true,
      tightLists: false,
      bulletListMarker: "-",
      transformPastedText: false,
      transformCopiedText: false,
      breaks: false
    }),
    Link.configure({
      openOnClick: true,
      HTMLAttributes: {
        class: "underline text-blue-500 hover:text-blue-600 cursor-pointer"
      }
    }),
    Table.configure({
      resizable: true,
      HTMLAttributes: {
        class: "border-collapse w-full"
      }
    }),
    TableRow.configure({
      HTMLAttributes: {
        class: "border-b border-gray-200"
      }
    }),
    TableHeader.configure({
      HTMLAttributes: {
        class: "border-b-2 border-gray-300 bg-gray-100 font-semibold text-left p-2 wrap-break-word min-w-0"
      }
    }),
    TableCell.configure({
      HTMLAttributes: {
        class: "border border-gray-200 p-2 wrap-break-word min-w-0"
      }
    }),
    Placeholder.configure({ placeholder }),
    TemplatePlaceholders
  ];
}
